import NiceSelect from "nice-select2/dist/js/nice-select2.js";
import copy from "copy-text-to-clipboard";

document.addEventListener("alpine:init", () => {
    let trackingSent = false;

    document.querySelectorAll(".custom-select").forEach((el) => {
        if (el.classList.contains("c-map-section__select")) {
            return;
        }
        new NiceSelect.default(el, { searchable: false, placeholder: el.dataset.placeholder ?? null });
    });

    document.querySelectorAll(".custom-select-searchable").forEach((el) => {
        new NiceSelect.default(el, { searchable: true, placeholder: el.dataset.placeholder ?? null });
    });

    const formFields = document.querySelectorAll(".calculator-form1 .trigger");
    formFields.forEach((field) => {
        if (field.tagName.toLowerCase() === "input") {
            field.addEventListener("input", (event) => {
                validateForm();
                calculateFiltrationRate();
            });
        } else if (field.tagName.toLowerCase() === "select") {
            field.addEventListener("change", (event) => {
                validateForm();
                calculateFiltrationRate();
            });
        }
    });

    const calculateFiltrationRate = () => {
        const sex = document.querySelector(".calculator-form1 #sex").selectedIndex;
        const age = document.querySelector(".calculator-form1 #alter-jahre").value;
        const serumcreatinin = parseInt(document.querySelector(".calculator-form1 #serumcreatinin").value);
        const unit = document.querySelector(".calculator-form1 #unit").selectedIndex;
        const result = document.querySelector(".calculator-form1 #resultat");

        let t = 0,
            i = 1,
            n = age,
            r = 0.9,
            a = -0.411,
            o = serumcreatinin;

        if (sex === 1) {
            i = 1.018;
            r = 0.7;
            a = -0.329;
        }

        if (unit === 0) {
            o = (113.12 * serumcreatinin) / 1e4;
        }

        if (isNaN(n) || isNaN(o)) {
            result.value = "";
        } else {
            let sum =
                141 * Math.pow(Math.min(o / r, 1), a) * Math.pow(Math.max(o / r, 1), -1.209) * Math.pow(0.993, n) * i;
            sum = Math.round(100 * sum) / 100;
            result.value = "eGFR: " + sum + " ml/min";
            console.log("sss", result.value);

            if (!trackingSent) {
                trackingPush({ event: "calculator_result", calculator_name: "Glomeruläre Filtrationsrate" });
                trackingSent = true;
            }
        }
    };

    const validateForm = () => {
        const numbersPattern = /^[0-9]+$/;
        const requiredFields = document.querySelectorAll(".calculator-form1 .required");
        requiredFields.forEach((field) => {
            if (field.value.match(numbersPattern)) {
                field.classList.remove("border-red");
            } else {
                field.classList.add("border-red");
            }
        });
    };

    const kopierenButton = document.querySelector(".calculator-form1 .kopieren-button");
    const iconCheck = document.querySelector(".calculator-form1 .icon-check");
    const iconCopy = document.querySelector(".calculator-form1 .icon-copy");

    if (kopierenButton) {
        kopierenButton.addEventListener("click", () => {
            const resultat = kopierenButton.parentElement.querySelector("#resultat").value;
            if (resultat) {
                navigator.clipboard.writeText(resultat);
                swapIcons(iconCheck);
                setTimeout(swapIcons, 3000, iconCopy);
            }
        });
    }

    const swapIcons = (toIcon) => {
        kopierenButton.querySelector("svg").remove();
        kopierenButton.appendChild(toIcon);
        kopierenButton.querySelector("svg").classList.remove("hidden");
    };
});
